interface StatusBadgeProps {
  estado: 'activa' | 'carencia' | 'suspendida';
  diasRestantes?: number;
  small?: boolean;
}

const smallConfig = {
  activa: { bg: 'bg-emerald-100', text: 'text-emerald-700', label: 'ACTIVA' },
  carencia: { bg: 'bg-amber-100', text: 'text-amber-700', label: 'EN CARENCIA' },
  suspendida: { bg: 'bg-red-100', text: 'text-red-700', label: 'SUSPENDIDA' },
};

export default function StatusBadge({ estado, diasRestantes = 0, small }: StatusBadgeProps) {
  if (small) {
    const c = smallConfig[estado];
    return (
      <span className={`${c.bg} ${c.text} whitespace-nowrap rounded-full px-2 py-0.5 text-[10px] font-black`}>
        {c.label}
      </span>
    );
  }

  if (estado === 'activa') {
    return (
      <div className="rounded-3xl border border-[#BDE7DA] bg-[#F1FBF7] px-5 py-4">
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-[#1D9E75] text-white">
            <i className="ri-checkbox-circle-line text-xl" />
          </span>
          <div>
            <p className="text-xs font-bold uppercase tracking-wide text-[#4A8774]">Membresia activa</p>
            <p className="text-sm font-black text-[#105B43]">Servicios del plan disponibles</p>
          </div>
        </div>
      </div>
    );
  }

  if (estado === 'carencia') {
    const progreso = Math.max(0, Math.min(100, Math.round(((90 - diasRestantes) / 90) * 100)));
    return (
      <div className="rounded-3xl border border-[#F4D28B] bg-[#FFF8E8] px-5 py-4">
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-[#F59E0B] text-white">
            <i className="ri-time-line text-xl" />
          </span>
          <div className="min-w-0 flex-1">
            <p className="text-xs font-bold uppercase tracking-wide text-[#9A6409]">Periodo de carencia</p>
            <p className="text-sm font-black text-[#6E4500]">{diasRestantes} dias para servicios completos</p>
          </div>
        </div>
        <div className="mt-3 h-2 rounded-full bg-[#F8E4B7]">
          <div className="h-2 rounded-full bg-[#F59E0B]" style={{ width: `${progreso}%` }} />
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-3xl border border-[#F3B6B6] bg-[#FFF1F1] px-5 py-4">
      <div className="flex items-center gap-3">
        <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-[#E24B4A] text-white">
          <i className="ri-error-warning-line text-xl" />
        </span>
        <div>
          <p className="text-xs font-bold uppercase tracking-wide text-[#9B2B2A]">Membresia suspendida</p>
          <p className="text-sm font-black text-[#6F1E1E]">Realiza tu pago para reactivarla</p>
        </div>
      </div>
    </div>
  );
}
